import { DataBean } from "../DataBean";

export class AttentionTicket extends DataBean {

    public async getAttentionTicket6(idCustomerType: number, idLn: number, idAccount: number, nit: number, idCharacterization: number, channelType: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickturn.bean.AttentionTicket_getAttentionTicket_Number_Number_Number_Number_Number_Number",
            [idCustomerType, idLn, idAccount, nit, idCharacterization, channelType]);
    }

    public async parseForInvokeJsonServiceFromAttentionTicket(idTicket: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickbpm.bean.ResponseValue_parseForInvokeJsonServiceFromAttentionTicket_Number",
            [idTicket]);
    }

    public async responseAttentionTicketForm(idTicket: number, responseValues: any,test: boolean ): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickturn.bean.AttentionTicket_responseAttentionTicketForm_Number_java.util.Map_Boolean",
            [idTicket, responseValues, test]);
    }

}
